import modelBaseV2 from "../model-base-v2.model";

const EXPORT_FILE = {
  URL: '/api/executesp/export/commonexcel',
  STORED_PROCEDURE_CODE: '52',
  PARAM_CODE: {
    PAGE_SIZE: '4',
    FROM_DATE: '8',
    TO_DATE: '9',
    COUNTRY_CODE: '16',
    STATUS: '23',
    SITE_ID: '31',
    RECIPIENT: '91',
    MESSAGE_TYPE: '92',
    TEXT: '93',
    CONDITION: '95',
    SENDER: '96',
    DIVISION: '97'
  }
}

const SMSLogModel = {
  getCodeMasterByCategory: (category, countryCode) => modelBaseV2.get(`/api/codemaster/search/${category}`, {
    params: { countryCode }
  }),
  getSMSLog: (body) => modelBaseV2.post('/api/sms/logs', { body }),
  commonExcelExport: (body, fileName = 'template') => {
    const exportConfig = {
      storedProcedureCode: EXPORT_FILE.STORED_PROCEDURE_CODE,
      params: [
        {
          code: EXPORT_FILE.PARAM_CODE.FROM_DATE,
          value: body.fromDate
        },
        {
          code: EXPORT_FILE.PARAM_CODE.TO_DATE,
          value: body.toDate
        },

        {
          code: EXPORT_FILE.PARAM_CODE.COUNTRY_CODE,
          value: body.countryCode
        },

        {
          code: EXPORT_FILE.PARAM_CODE.STATUS,
          value: body.status
        },

        {
          code: EXPORT_FILE.PARAM_CODE.RECIPIENT,
          value: body.recipient
        },

        {
          code: EXPORT_FILE.PARAM_CODE.MESSAGE_TYPE,
          value: body.messageType
        },

        {
          code: EXPORT_FILE.PARAM_CODE.TEXT,
          value: body.searchText
        },

        {
          code: EXPORT_FILE.PARAM_CODE.SITE_ID,
          value: body.channel
        },
        {
          code: EXPORT_FILE.PARAM_CODE.CONDITION,
          value: body.condition
        },
        {
          code: EXPORT_FILE.PARAM_CODE.SENDER,
          value: body.senderNo
        },
        {
          code: EXPORT_FILE.PARAM_CODE.DIVISION,
          value: body.division
        }

      ]
    }
    return modelBaseV2.postDownload(
      EXPORT_FILE.URL,
      {
        body: exportConfig
      },
      fileName
    )
  }
}

export default SMSLogModel;